import React, { useState } from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    Col,
    FormGroup,
    Input,
    Row,
    Label,
    Spinner
} from 'reactstrap';
import { collection, addDoc } from "firebase/firestore";
import { createQuestion } from "../../util/SheetManager";
import { getDb } from "../../util/Constants";


function AddDepartment(props) {
    const [department, setDepartment] = useState("");
    const [load, setLoad] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoad(true);
        let dataCapital=department.charAt(0).toUpperCase() + department.slice(1)
        const payload = {
            department: dataCapital
        }

        await addDoc(collection(getDb(), "departments"), payload);
        props.getDepartments();
        // props.setDepartments([...props.departments, { department: department }])

        setLoad(false)
        props.toggle()
        setDepartment("")
    };

    return (
        <div>

            <Modal isOpen={props.modal} toggle={props.toggle}>
                <ModalHeader toggle={props.toggle}>Add Department</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>

                        <div className="">

                            <FormGroup>
                                <Label for="department">
                                    Department Name
                                </Label>
                                <Input
                                    type="text"
                                    id="department"
                                    maxLength={20}
                                    value={department}
                                    required
                                    className="form-control-alternative"
                                    onChange={(e) => setDepartment(e.target.value)}
                                />

                            </FormGroup>
                        </div>

                        <Button color="primary" type="submit" disabled={load}>
                            {load ? (
                                <Spinner color="light" size="sm" />
                            ) : (
                                "Save"
                            )}

                        </Button>
                        <Button color="secondary" onClick={props.toggle}>
                            Cancel
                        </Button>
                    </Form>
                </ModalBody>

            </Modal>
        </div>);
}


export default AddDepartment;